
    import { Component, Prop } from 'vue-property-decorator';
    import ModalView from '@/components/helper/modal-view.vue';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';

    @Component({
        components: { ModalView },
        watch: {
            value: function (val) {
                let obj = (this as any);
                obj.modalShow = val;
                if (val) {
                    obj.initForm();
                }
            },
            modalShow: function (val) {
                if (!val) {
                    this.$emit('input', false);
                }
            }
        }
    })

    export default class ImportChangesView extends ListBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        file: any = null;
        modalSetting: any = {
            entity: "workshopinfo",
            width: "95%",
            showForm: false,
            titleFull: 'Importar Listado',
            icon: 'mdi-upload',
            saveText: 'Actualizar Listado',
            saveIcon: 'mdi-upload',
            disabledSave: true,
            customSave: true,
            //showFootActions: false,
            persistent: false
        };
        
        columns = [
            this.gCol('code', 'DNI', 'text'),
            this.gCol('firstname', 'Apellidos', 'text'),
            this.gCol('lastname', 'Nombres', 'text'),
            this.gCol('manufacturer_name', 'Marca', 'text'),
            this.gCol('dealer_name', 'Empresa', 'text'),
            this.gCol('city', 'Ciudad', 'text'),
            this.gColO({ type: 'text', value: 'function_id', text: 'Funcion principal', generalType: true }),
            this.gCol('phone', 'Telefono', 'text'),
            this.gCol('movil', 'Movil', 'text'),
            this.gCol('email', 'Direccion de e-mail', 'text'),
            this.gCol('birthdate', 'Fecha de nacimiento', 'date'),
        ]

        get disabled() {
            if (this.file == null) return true;
            else return false
        }
        get loading() {
            return this.$store.state.workshopinfo.loading;
        }
        get list() {
            return this.$store.state.workshopinfo.reportList;
        }
        get totalCount() {
            return this.list.length;
        }

        getValue(id: number) {
            return Util.abp.list.getName(id);
        }

        initForm() {
            this.modalSetting.titleFull = "Importar Lista";
            this.modalSetting.saveText = "Actualizar Lista";
        }

        async importFile() {
            this.modalSetting.disabledSave = true;
            if (this.file == null) return;

            let formData = new FormData();
            formData.append('file', this.file);

            let result = await this.$store.dispatch({
                type: 'workshopinfo/importData',
                data: formData
            });

            if (result) {
                if (this.totalCount > 0) {
                    this.$toast.info('Primero Revise los datos Importados, <br/>Luego Presione "Actualizar Listado" para completar el proceso', { timeout: 5000 });
                    this.modalSetting.disabledSave = false;
                } else
                    this.$toast.warning('No se detectaron cambios en los registros', { timeout: 3000 });
            }
        }

        async save() {
            if (this.totalCount > 0) {

                let newModel = await this.$store.dispatch({
                    type: 'workshopinfo/updateBatch',
                    data: {
                        items: this.list
                    }
                });

                this.$toast.success('Registros Actualizados');
                this.$emit('save-success');
                this.cancel();

                return newModel;
            } else
                return false;
        }

        cancel() {
            this.file = null;
            this.$store.commit('workshopinfo/setReportList', []);
            this.$emit('input', false);
        }

        mounted() {
        }

        created() {
        }
    }
